<script>

import vue2Dropzone from 'vue2-dropzone'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import ImportForm from '@components/import-form'

export default {

	page: {
		title: 'Импорт пользователей',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect, vueDropzone: vue2Dropzone, ImportForm },

	data() {
        return {
			title: 'Импорт контактов',
			items: [
				{
					text: 'Личный кабинет',
					href: '/account',
				},
                {
                    text: 'Импорт контактов',
                    active: true,
                },
			],
            dropzoneOptions: {
                url: 'https://api.client.za-bota.com/v1/imports/upload/',
                thumbnailWidth: 30,
                maxFilesize: 10,
                params: {
                    'type': 'contacts',
                    'token': ''
                }
            },
            dropzoneShow: true,

            showForm: false,
            trackBy: 'id',

            status: '',
            status_options: [
                {id: 'active', name: 'Активен'},
                {id: 'wait', name: 'Ожидает активации'},
                {id: 'blocked', name: 'Заблокирован'},
            ],

            contact_category: null,
            contact_category_options: [],

            file_path: null,
            file_name: null,

            fullname: null,
            fullname_options: [],

            name1: null,
            name1_options: [],

            name2: null,
            name2_options: [],

            name3: null,
            name3_options: [],

            phone: null,
            phone_options: [],

            email: null,
            email_options: [],

            qnt: 0,

            isAdmin: false,

            isSubmitErrorData: null,
            alertMessage: null,
            alertVariant: null
		}
	},

    watch: {

    },

	computed: {
        contacts_categories_list_data(){
            
            return this.$store.getters['contactsCategories/GET_CONTACTS_CATEGORIES_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user;
        },
	},

	async mounted() {

        await this.$store.dispatch('contactsCategories/FETCH_CONTACTS_CATEGORIES_LIST', {'sortBy': 'id', 'sortDesc': 'DESC'});
        this.contact_category_options = this.contacts_categories_list_data;

        if(this.session_user_item && this.session_user_item.role === 'administrator'){
            this.isAdmin = true;
        }

        this.dropzoneOptions.params.token = window.localStorage.getItem('API_KEY_ZABOTA');
	},

	methods: {

        async importData(){

            let err = false;
            let err_message = '';

            if(!this.phone || !this.phone.id){
                err = true;
                err_message = 'Номер телефона';
            }
            if(!this.contact_category || !this.contact_category.id){
                err = true;
                if(err_message !== ''){
                    err_message = err_message + ', ';
                }
                err_message = err_message + 'Группа контактов';
            }

            if(err === true){
                this.isSubmitErrorData = true;
                this.alertMessage = 'Не все обязательные поля были заполнены: ' + err_message;
                this.alertVariant = 'danger';
                
                return false;
            }

            let data_import = {
                'indx' : {
                    'fullname': this.fullname && this.fullname.id ? this.fullname.id - 1 : '',
                    'name1': this.name1 && this.name1.id ? this.name1.id - 1 : '',
                    'name2': this.name2 && this.name2.id ? this.name2.id - 1 : '',
                    'name3': this.name3 && this.name3.id ? this.name3.id - 1 : '',
                    'phone': this.phone && this.phone.id ? this.phone.id - 1 : '',
                    'email': this.email && this.email.id ? this.email.id - 1 : '',
                },
                'params' : {
                    'owner_id': this.session_user_item && this.session_user_item.id ? this.session_user_item.id : '',
                    'status': this.status && this.status.id ? this.status.id : 'active',
                    'category_id': this.contact_category && this.contact_category.id ? this.contact_category.id : '',
                }
            };

            if(this.file_path !== null) {

                let data_send = {
                    'name' : 'contacts',
                    'qnt' : this.qnt,
                    'status' : 'wait',
                    'more_data': JSON.stringify(data_import),
                    'filename' : this.file_name,
                    'filepath' : this.file_path
                };

                let response = await this.$store.dispatch('imports/FETCH_IMPORTS_CREATE', data_send);

                if (response === false) {
                    alert('При загрузке возникла ошибка');
                    this.$refs.myVueDropzone.removeAllFiles();
                } else {
                    this.$router.push({name: 'Imports.Contacts'});
                }

            } else {
                alert('При загрузке возникла ошибка');
                this.$refs.myVueDropzone.removeAllFiles();
                return false;
            }
        },

        uploadSuccess(file, response) {

            response = JSON.parse(response);

            this.$refs.myVueDropzone.removeAllFiles();

            if(response && response.status === 'success') {

                let options_arr = [];
                let i = 1;
                let data_arr = response.data.columns;

                data_arr.forEach(el => {
                    options_arr.push({
                        id: i,
                        name: el,
                    });
                    i++;
                });

                this.fullname_options = options_arr;
                this.name1_options = options_arr;
                this.name2_options = options_arr;
                this.name3_options = options_arr;
                this.phone_options = options_arr;
                this.email_options = options_arr;
                this.file_name = response.data && response.data.filename ? response.data.filename : '';
                this.file_path = response.data && response.data.filepath ? response.data.filepath : '';

                this.showForm = true;

            } else {
                alert('При загрузке возникла ошибка');
                return false;
            }
        },

        uploadError(file, message) {

        },
	}
}

</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <ImportForm />
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
	</Layout>
</template>

<style>
    .dz-preview {
        padding: 15px
    }
    .dz-progress {
        display: none;
    }
    .dz-success-mark, .dz-error-mark {
        display: none;
    }
</style>